import { defineMessages } from 'react-intl';

export default defineMessages({
  filterByProfession: {
    id: 'global_filter_by_profession',
    defaultMessage: 'Resultados em {%s} para:',
  },
  filterByLocation: {
    id: 'global_filter_by_location',
    defaultMessage: 'Filtrar vagas por:',
  },
  viewMoreProfessions: {
    id: 'global_view_more_professions',
    defaultMessage: 'Mostrar mais profissões',
  },
  viewMoreLocations: {
    id: 'global_view_more_locations',
    defaultMessage: 'Mostrar mais localizações',
  },
  anyLocation: {
    id: 'global_any_location',
    defaultMessage: 'Qualquer localização',
  },
  anyProfession: {
    id: 'global_any_profession',
    defaultMessage: 'Qualquer profissõao',
  },
});



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/list/messages.js